import {FC} from 'react';
import {Control, Controller} from 'react-hook-form';
import {ICredentialsForm} from 'core';
import {Input} from 'ui-kit';
import {Flex} from '@chakra-ui/react';

interface IProps {
  control: Control<ICredentialsForm>;
  onSetRequestError: (error: string) => void;
}

export const BaseFieldsForm: FC<IProps> = ({control, onSetRequestError}) => {
  return (
    <Flex flexDirection={'column'} gap={'16px'}>
      <Controller
        control={control}
        name={`username`}
        rules={{required: true}}
        render={({field: {onChange, value}}) => {
          return (
            <Input
              id={'credentials-username'}
              value={value}
              autoComplete={'off'}
              placeholder={'Email'}
              onChange={(e) => {
                onSetRequestError('');
                onChange(e.target.value);
              }}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={`password`}
        rules={{required: true}}
        render={({field: {onChange, value}}) => {
          return (
            <Input
              id={'credentials-password'}
              value={value}
              type={'password'}
              autoComplete={'off'}
              placeholder={'Password'}
              onChange={(e) => {
                onSetRequestError('');
                onChange(e.target.value);
              }}
            />
          );
        }}
      />
    </Flex>
  );
};
